import { render, staticRenderFns } from "./newDevice.vue?vue&type=template&id=16a4681c&"
import script from "./newDevice.vue?vue&type=script&lang=js&"
export * from "./newDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports